import React, { Fragment, useContext } from "react";

import { EligibilityContext } from "../../contexts/EligibilityContext";
import Icon from "../Icon";

const Crumbs = props => {
  const context = useContext(EligibilityContext);

  const handleNav = (event, step) => {
    event.preventDefault();
    if (step <= context.state.step) {
      context.actions.setStep(step);
    }
  };

  const Crumb = itemProps => {
    const minStep = Math.min.apply(
      Math,
      itemProps.steps.map(step => step.number)
    );
    const maxStep = Math.max.apply(
      Math,
      itemProps.steps.map(step => step.number)
    );

    const filteredStep = itemProps.steps.filter(step => {
      return step.number === context.state.step;
    })[0];

    const label = (filteredStep || {}).label || itemProps.defaultLabel;

    const icon =
      // Icon is a number, turns into a checkmark when the step is a previous step
      context.state.step <= maxStep ? (
        itemProps.number
      ) : (
        <Icon name="check" width="12" height="9" />
      );

    return (
      <Fragment>
        {props.static && (
          <li
            className={`WizardSteps-item c-white ${itemProps.number === 1 &&
              "active"}`}
          >
            <span className="WizardSteps-button">
              <span className="WizardSteps-button-icon">
                {itemProps.number}.
              </span>{" "}
              {label}
            </span>
          </li>
        )}

        {!props.static && (
          <li
            className={`WizardSteps-item c-white${
              itemProps.steps
                .map(step => step.number)
                .includes(context.state.step)
                ? " active"
                : ""
            }`}
          >
            <button
              // Disabled if it is a future step. Disable the eligibility link if the fund is closed
              disabled={
                context.state.step <= minStep ||
                (itemProps.number === 2 &&
                  (context.state.diseaseFund || {}).fundStatus === "closed")
              }
              onClick={event => handleNav(event, minStep)}
              className="WizardSteps-button"
            >
              <span className="WizardSteps-button-icon">{icon}</span> {label}
            </button>
          </li>
        )}
      </Fragment>
    );
  };

  return (
    <ol
      aria-hidden="true"
      className={`WizardSteps ${props.static && "WizardSteps--static"}`}
    >
      <Crumb
        number={1}
        defaultLabel="Search"
        steps={[{ number: 1, label: "Search" }]}
      />
      <Crumb
        number={2}
        defaultLabel="Eligibility"
        steps={[
          { number: 2, label: "Eligibility" },
          { number: 3, label: "Eligibility" }
        ]}
      />
      <Crumb
        number={3}
        defaultLabel="Apply"
        steps={[
          {
            number: 4,
            label: "Apply"
          },
          {
            number: 5,
            label: "Resources"
          },
          {
            number: 6,
            label: "Resources"
          },
          {
            number: 7,
            label: "Resources"
          },
          {
            number: 8,
            label: "Resources"
          },
          {
            number: 9,
            label: "Apply"
          }
        ]}
      />
    </ol>
  );
};

export default Crumbs;
